import { useStoreUtils } from "./utils";

export const useBonusStore = () => {
    const { createCurrencyValue, getStore } = useStoreUtils();

    /**
     * Available balance store names
     * @type {string[]}
     */
    const bonusNames = ["total", "wagering", "wager_completion", "wager"];

    /**
     * Initializes the bonus store with support for multiple bonus types
     * Includes expiration date formatting and store reset functionality
     */
    const init = () => {
        // initialize will all bonuses:
        window.Alpine.store("active_bonus", {
            ...Object.fromEntries(
                bonusNames.map((b) => [b, createCurrencyValue()]),
            ),
            title: window.appContext?.Player?.active_bonus?.title ?? "",
            expired_at: {
                _value: null,
                _text: "",
                get value() {
                    return this._value;
                },
                set value(v) {
                    this._value = v;
                    this._text =
                        v instanceof Date
                            ? new Intl.DateTimeFormat(
                                  getStore("locale")?.short,
                              ).format(v)
                            : "";
                },
                get text() {
                    return this._text;
                },
            },
            created_at: {
                _value: null,
                _text: "",
                get value() {
                    return this._value;
                },
                set value(v) {
                    this._value = v;

                    const locale = getStore("locale")?.short;

                    this._text =
                        v instanceof Date
                            ? new Intl.DateTimeFormat(locale, {
                                  year: "numeric",
                                  month: "short",
                                  day: "2-digit",
                              }).format(v)
                            : "";
                },
                get text() {
                    return this._text;
                },
            },
            clear() {
                bonusNames.forEach((b) => (this[b].value = 0));
                this.title = "";
                this.expired_at.value = null;
                this.created_at.value = null;
            },
        });

        window.Alpine.store("bonus", {
            selected: null,
            useBonus: true,
        });

        if (window.appContext.Player) {
            const store = getStore("active_bonus");
            // use setter for underlying updates
            bonusNames.forEach((b) => {
                store[b].value =
                    window.appContext.Player.active_bonus?.[b] ?? "0";
            });
            store.expired_at.value = window.appContext.Player.active_bonus
                ?.expired_at
                ? new Date(window.appContext.Player.active_bonus?.expired_at)
                : null;
            store.created_at.value = window.appContext.Player.active_bonus
                ?.created_at
                ? new Date(window.appContext.Player.active_bonus?.created_at)
                : null;
        }

        setTimeout(() => {
            const locale = getStore("locale")?.short;
            const store = getStore("active_bonus");

            if (!locale || !store) return;

            if (store.expired_at.value instanceof Date) {
                store.expired_at.value = store.expired_at.value;
            }
            if (store.created_at.value instanceof Date) {
                store.created_at.value = store.created_at.value;
            }
        }, 0);
    };

    return { init, bonusNames };
};
